import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_CASHOPS_SCHEMA_LITERAL = {
    title: 'Schéma CashOps',
    description: 'CashOps',
    version: 0,
    keyCompression: false,
    primaryKey: 'PK_ID',
    type: 'object',
    properties: {
        PK_ID : { type : 'string', maxLength : 100 },
        MD_SITEGID : { type : 'string' },
        MD_SITE : { type : 'string' },
        MD_CAISSE : { type : 'string' },
        MD_CAISSE_LIB : { type : 'string' },
        MD_CAISSIERGID : { type : 'string' },
        MD_CAISSIER : { type : 'string' },
        MD_CAISSIER_LIB : { type : 'string' },
        MD_CAISSE_SESSION : { type : 'string' },
        MD_LOCALGID : { type : 'string' },
        MD_DATE_CREATION : { type : 'string' },
        MD_CBMARQ : { type : 'number' },
        EC_FLAG : { type : 'string' },
        EC_DATE_ECR : { type : 'string' },
        EC_DATE : { type : 'string' },
        EC_HEURE : { type : 'string' },
        EC_REFERENCE : { type : 'string' },
        EC_CATEGORIE : { type : 'string' },
        EC_CATEGORIE_LIB : { type : 'string' },
        EC_NATURE : { type : 'string' },
        EC_NATURE_LIB : { type : 'string' },
        JO_NUM : { type : 'string' },
        CG_NUM : { type : 'string' },
        CG_NUM_J : { type : 'string' },
        EC_INTITULE : { type : 'string' },
        EC_SENS : { type : 'string' },
        EC_MONTANT : { type : 'number' },
        N_REGLEMENT : { type : 'string' },
        N_REGLEMENTLIB : { type : 'string' }, 
        ANA_ITEMS_JSON : { type : 'string' },
        ZSYNCUP_FLAG  : { type : 'number', default : 0 },
        ZSYNCUP_STATUS  : { type : 'string' },
        ZSYNCUP_ERROR_MESSAGE  : { type : 'string' },
        ZSYNCUP_DATETIME  : { type : 'string' },
        ZSYNCUP_FEEDID  : { type : 'string' },
        ZCLIENT_STATUS : { type : 'number', default : 0 }
    },
    required: [ ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_CASHOPS_SCHEMA_LITERAL);
export type RxCluCashOpsDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_CASHOPS_SCHEMA: RxJsonSchema<RxCluCashOpsDocumentType> = CLU_CASHOPS_SCHEMA_LITERAL;
